import RouterView from '@/page/main/DefaultRouterView'
import Type from '@/page/asset/type'
import Create from '@/page/asset/create'
import Edit from '@/page/asset/edit'
import Repair from '@/page/asset/Repair'

import List from '@/page/asset/list'
import InventoryList from '@/page/asset/inventoryList'
import MyList from '@/page/asset/myList'
import MyFinanceList from '@/page/asset/myFinanceList'
import ChangeList from '@/page/asset/changeList'
import RepairList from '@/page/asset/repairList'

import SupplierList from '@/page/asset/supplierList'
// 资产属性
import Attribute from '@/page/asset/attributeList'
// 资产所属部门
import Dept from '@/page/asset/assetDept'

// 资产调拨
import Allot from '@/page/asset/allot'
import AllotList from '@/page/asset/allotList'
// 资产处置
import Handle from '@/page/asset/handle'
import HandleList from '@/page/asset/handleList'


export default {
  path: '/Asset',
  component: RouterView,
  children: [{
    path: 'Inventory/List',
    meta: {
      type: ['asset', 'assetInventory'],
      title: '资产盘点列表'
    },
    component: InventoryList
  }, {
    path: 'MyFinanceList',
    meta: {
      type: ['asset', 'myFinanceList'],
      title: '资产入库财务确认'
    },
    component: MyFinanceList
  }, {
    path: 'MyList',
    meta: {
      type: ['asset', 'myList'],
      title: '与我相关的资产'
    },
    component: MyList
  }, {
    path: 'Allot',
    meta: {
      type: ['asset', 'allotList'],
      title: '资产调拨'
    },
    component: Allot
  }, {
    path: 'AllotList',
    meta: {
      type: ['asset', 'allotList'],
      title: '资产调拨列表'
    },
    component: AllotList
  }, {
    path: 'Handle',
    meta: {
      type: ['asset', 'handleList'],
      title: '资产处置'
    },
    component: Handle
  }, {
    path: 'HandleList',
    meta: {
      type: ['asset', 'handleList'],
      title: '资产处置列表'
    },
    component: HandleList
  }, {
    path: 'Create',
    meta: {
      type: ['asset', 'assetcreate'],
      title: '资产入库'
    },
    component: Create
  }, {
    path: 'Type',
    meta: {
      type: ['asset', 'assettype'],
      title: '资产类别设置'
    },
    component: Type
  }, {
    path: 'List',
    meta: {
      type: ['asset', 'assetlist'],
      title: '资产列表'
    },
    component: List
  }, {
    path: 'Edit',
    meta: {
      type: ['asset', 'assetchangelist'],
      title: '资产变更'
    },
    component: Edit
  }, {
    path: 'Repair/:id?',
    meta: {
      type: ['asset', 'assetrepairlist'],
      title: '资产维修'
    },
    component: Repair
  }, {
    path: 'ChangeList',
    meta: {
      type: ['asset', 'assetchangelist'],
      title: '资产变更记录'
    },
    component: ChangeList
  }, {
    path: 'RepairList',
    meta: {
      type: ['asset', 'assetrepairlist'],
      title: '资产维修记录'
    },
    component: RepairList
  }, {
    path: 'SupplierList/:type',
    meta: {
      type: ['asset', 'assetSupplierList'],
      title: '资产供应商列表'
    },
    component: SupplierList
  }, {
    path: 'Attribute',
    meta: {
      type: ['asset', 'assetAttribute'],
      title: '资产属性列表'
    },
    component: Attribute
  }, {
    path: 'Dept',
    meta: {
      type: ['asset', 'assetDept'],
      title: '资产所属部门'
    },
    component: Dept
  }, ]
}


// WEBPACK FOOTER //
// ./src/router/asset.js